import type { SVGProps } from 'react';

type Props = {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
    svgProps?: SVGProps<SVGSVGElement>;
};

const FooterBackIcon = ({ color = 'currentColor', width = 24, height = 24, className, svgProps }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" className={className} {...svgProps}>
            <path d="M9.8314 4.99985L1.85938 12.3075L9.8314 19.6152" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 12.3066H2" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        </svg>
    );
};

export default FooterBackIcon;
